import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import PricingService from 'wanderu-service-pricing';

import { actions as pricingActions } from '../../data/pricing';
import { actions } from './base';

const logger = Logger.getLogger('wanderu-ducks-pricing');

function reset() {
    return actions.reset();
}

function fetch({
    originPlaceId, destinationPlaceId, fromDate, toDate, currency,
}) {
    const key = `${originPlaceId}-${destinationPlaceId}-${fromDate}-${toDate}`;

    return async (dispatch) => {
        dispatch(actions.startWork(key));

        let error;
        let meta = {
            fromDate,
            toDate,
        };

        try {
            const request = {
                originPlaceId,
                destinationPlaceId,
                fromDate,
                toDate,
                currency,
            };

            const minimumPrices = await PricingService.getMinimumPricesForDateRange(request);
            const data = Object.entries(minimumPrices).map(([date, price]) => ({
                originPlaceId,
                destinationPlaceId,
                date,
                price,
            }));

            return dispatch(
                pricingActions.setDailyMinimumPricing(data, meta),
            );
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.error('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                code: ex.code,
                message: ex.message,
                name: ex.name,
            };
        } finally {
            dispatch(actions.endWork(key, {}, error));
        }
    };
}

export {
    fetch,
    reset,
};
